import { Grid, Header, SpaceBetween } from '@amzn/awsui-components-react';
import React, { useEffect, useState } from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { BRC_ITEMS_PAGE } from '../../common/components/with_page/components/bread_crumb/constants';
import Page from '../../common/components/with_page/Page';
import { isPayrollDataAccessible, RESOURCE } from '../auth/constants/rbac_constants';
import ReportCards from './components/report_cards/ReportCards';
import ReportTable from './components/report_table/ReportTable';
import {
  getDecoratedReportCards,
  REPORT_CARDS,
  REPORT_CARDS_FOR_US_DUAL_ALLOCATION,
} from './constants/report_cards';
import { getStudyPeriod } from '../../common/constants/study_period';
import { STUDY_TYPE } from '../../redux/reducers/studyTypeReducers';

const AnalyticsPage = ({ reportingData, studyPeriod, entityId, studyType }) => {
  const initialReportCards =
    STUDY_TYPE.US_DUAL_ALLOCATION === studyType
      ? REPORT_CARDS_FOR_US_DUAL_ALLOCATION
      : REPORT_CARDS;

  const [reportCards, setReportCards] = React.useState(initialReportCards);
  const [selectedReportCards, setSelectedReportCards] = useState([initialReportCards[0]]);

  const setDecoratedReportCards = cards => {
    setReportCards(getDecoratedReportCards({ reportCards: cards, reportingData }));
  };

  useEffect(() => {
    setDecoratedReportCards(reportCards);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportingData]);

  useEffect(() => {
    setReportCards(initialReportCards);
    setSelectedReportCards([initialReportCards[0]]);
  }, [initialReportCards, studyPeriod]);

  const getSelectedReportCard = () => {
    return get(selectedReportCards, [0], initialReportCards[0]);
  };

  const content = (
    <SpaceBetween size="l">
      <Header variant="h1">Analytics</Header>
      <Grid gridDefinition={[{ colspan: 3 }, { colspan: 9 }]}>
        <ReportCards
          reportCards={reportCards}
          setReportCards={setDecoratedReportCards}
          selectedReportCards={selectedReportCards}
          setSelectedReportCards={setSelectedReportCards}
        />
        <ReportTable selectedReportCard={getSelectedReportCard()} />
      </Grid>
    </SpaceBetween>
  );

  return (
    <Page
      PageId={RESOURCE.PAGE_ANALYTICS}
      isPageAccessControlled
      customAccessControl={isPayrollDataAccessible}
      PageContent={content}
      breadCrumbItems={BRC_ITEMS_PAGE.ANALYTICS(studyPeriod, entityId, studyType)}
    />
  );
};

AnalyticsPage.propTypes = {
  reportingData: PropTypes.object.isRequired,
  studyPeriod: PropTypes.string.isRequired,
  entityId: PropTypes.string,
  studyType: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  reportingData: get(state, 'entities.reporting.data', {}) || {},
  studyPeriod: getStudyPeriod(state),
  entityId: get(state, 'entityId.entityId', undefined),
  studyType: get(state, 'studyType.studyType'),
});

export default connect(mapStateToProps)(AnalyticsPage);
